import { GetCitiesListRequestParams } from "api/request/common.request";

/* eslint-disable import/prefer-default-export */
export const commonQueryKeys = {
  featureFlags: ["featureFlags"],
  currencies: ["currencies"],
  countries: (useV2: boolean = false) => ["countries", useV2],
  airports: (query: string) => ["airports", query],
  airlines: (query: string) => ["airlines", query],
  seaports: (query: string) => ["seaports", query],
  timezones: (filters: any) => ["timezones", filters],
  flightData: (config: Record<string, any>) => ["flightData", config],
  freightModes: (config: Record<string, any>) => ["freightModes", config],
  attachmentBuckets: (paymentLocation: string, isQuickRequest: boolean = false) => [
    "attachmentBuckets",
    paymentLocation,
    isQuickRequest,
  ],
  cities: (filters: GetCitiesListRequestParams) => ["cities", filters],
  statesV2: (countryId: number) => ["statesV2", countryId],
  locodes: (countryId: number) => ["locodes", countryId],
  truckCoordinates: (coords: string) => ["truckCoordinates", coords],
  useGetRequestStartingPoint: ["requestStartingPoint"],
};
